import { createContext } from "react";

export const EstimatePresetStoreContext = createContext(null);